import { withDone } from '@rad/utility/http';
import { konstPromise, mapPromise } from '../../utility/promise';
import { getMeasures, getMeasureCategories } from '../../../../client/types';
const staticSourceOptions = (xs) => konstPromise(xs.map((x) => ({ 'id': x, 'label': x })));
const sourceOptions = {
    // 'scorecard':(async () => (await withDone(getScorecards())()).map((x) => ({ 'id':x.id,'label':x.title })))(),
    'measure': (async () => (await withDone(getMeasures())()).map((x) => ({ 'id': x.id, 'label': x.display })))(),
    'measure-category': (async () => (await withDone(getMeasureCategories())()).map((x) => ({ 'id': x, 'label': x })))(),
    'measure-direction': staticSourceOptions(['Upward', 'Downward']),
    'measure-precision-m': staticSourceOptions(['0', '1', '2']),
    'measure-precision-sm': konstPromise([
        { 'id': null, 'label': 'Use Measure Standard' },
        { 'id': '0', 'label': '0' },
        { 'id': '1', 'label': '1' },
        { 'id': '2', 'label': '2' },
    ]),
    'measure-score-type': staticSourceOptions([
        'Number',
        'Percentage',
        'Percentile',
        'Pass/Fail',
        'Threshold/Target/Max',
    ]),
    'measure-aggregation': konstPromise([
        { 'id': 'AVERAGE', 'label': 'AVERAGE', 'group': 'Standard' },
        { 'id': 'AVG_SCORES', 'label': 'AVG_SCORES', 'group': 'Standard' },
        { 'id': 'DCOUNT', 'label': 'DCOUNT', 'group': 'Standard' },
        { 'id': 'SUM', 'label': 'SUM', 'group': 'Standard' },
        { 'id': 'SUM_AVG', 'label': 'SUM_AVG', 'group': 'Standard' },
        { 'id': 'SETVALUE', 'label': 'SETVALUE', 'group': 'Standard' },
        { 'id': 'SETVALUE_SUM', 'label': 'SETVALUE_SUM', 'group': 'Standard' },
        { 'id': 'CIRCUIT_BREAKER', 'label': 'CIRCUIT_BREAKER', 'group': 'Logic' },
        { 'id': 'MEETING', 'label': 'MEETING', 'group': 'Logic' },
        { 'id': 'REDUCE_SCORE', 'label': 'REDUCE_SCORE', 'group': 'Logic' },
        { 'id': 'SLIDING_SCALE', 'label': 'SLIDING_SCALE', 'group': 'Logic' },
        { 'id': 'PRESSGANEY', 'label': 'PRESSGANEY', 'group': 'Press Ganey' },
        { 'id': 'PRESSGANEYRANK', 'label': 'PRESSGANEYRANK', 'group': 'Press Ganey' },
        { 'id': 'PRESSGANEYRANK30NEW', 'label': 'PRESSGANEYRANK30NEW', 'group': 'Press Ganey' },
        { 'id': 'ANNUALIZE_NORMALIZE_1FTE', 'label': 'ANNUALIZE_NORMALIZE_1FTE', 'group': 'Other' },
        { 'id': 'CHANGE', 'label': 'CHANGE', 'group': 'Other' },
        { 'id': 'CHANGEPROJECTED', 'label': 'CHANGEPROJECTED', 'group': 'Other' },
        { 'id': 'NEGATIVE_POINTS', 'label': 'NEGATIVE_POINTS', 'group': 'Other' },
        { 'id': 'NETWORK_ROLLUP', 'label': 'NETWORK_ROLLUP', 'group': 'Other' },
        { 'id': 'PER1000', 'label': 'PER1000', 'group': 'Other' },
        { 'id': 'SLPG_MPM_ROLLUP', 'label': 'SLPG_MPM_ROLLUP', 'group': 'Other' },
        { 'id': 'SPHOURS', 'label': 'SPHOURS', 'group': 'Other' },
        { 'id': 'EPIC_ROLLUP', 'label': 'EPIC_ROLLUP', 'group': 'Other' },
        { 'id': 'INSIGHTS_SETVALUE', 'label': 'INSIGHTS_SETVALUE', 'group': 'Other' },
        { 'id': 'INVESTMENTFTE', 'label': 'INVESTMENTFTE', 'group': 'Other' },
        { 'id': 'NEWVISITSFTE', 'label': 'NEWVISITSFTE', 'group': 'Other' },
        { 'id': 'NORMALIZE_1FTE', 'label': 'NORMALIZE_1FTE', 'group': 'Other' },
        { 'id': 'VISITSPERDAY', 'label': 'VISITSPERDAY', 'group': 'Other' },
        { 'id': 'YOYFINANCE', 'label': 'YOYFINANCE', 'group': 'Other' },
    ]),
};
export const sources = Object.keys(sourceOptions).map((k) => ({
    'id': k,
    'label': k.split('-').map((x) => `${x[0].toUpperCase()}${x.substring(1)}`).join(' '),
}));
export const sourceToOptions = async (x, required) => x === null || x.id === null
    ? [{ 'id': '_1', 'label': 'Sample Option 1' }, { 'id': '_2', 'label': 'Sample Option 2' }, { 'id': '_3', 'label': 'Sample Option 2' }]
    : !!x.options
        ? x.options
        : x.id in sourceOptions
            ? mapPromise(sourceOptions[x.id], (xs) => [...(xs[0].id === null || xs[0].id === '' ? [] : [required ? { 'id': '', 'label': 'Select one...' } : { 'id': null, 'label': 'Select one...' }]), ...xs])
            : [{ 'id': '', 'label': 'Unrecognized Source' }];
const kinds = {
    'text': {
        'value': '',
        'settings': {
            'special': 'plain',
            'tooltip': undefined,
        },
    },
    'number': {
        'value': null,
        'settings': {
            'precision': null,
            'tooltip': undefined,
        }
    },
    'color': {
        'value': null,
        'settings': {},
    },
    'select': {
        'value': null,
        'settings': {
            'source': null,
            'autocomplete': false,
            'tooltip': undefined,
        },
    },
    // 'multiselect':{
    //   'value':[] as string[],
    //   'settings':{
    //     'kind':'multiselect',
    //     'source':null as { 'kind':string;'id':string } | null
    //   },
    // },
    'checkbox': {
        'value': false,
        'settings': {},
    },
    'date': {
        'value': null,
        'settings': {},
    },
    'time': {
        'value': null,
        'settings': {},
    },
    'datetime': {
        'value': null,
        'settings': {},
    },
    // 'files':{
    //   'value':[] as File[],
    //   'settings':{
    //     'kind':'files',
    //     'count':null as number | null
    //   },
    // },
};
export const kindDefault = (x) => kinds[x];
export const unsafeReifyForm = (x) => ({
    'columns': x.columns,
    'fields': x.fields.map((x) => (f) => f({
        ...x,
        // 'value':kindDefault(x.kind).value,
        'settings': (x.kind === 'select'
            ? {
                ...x.settings,
                'source': {
                    ...x.settings.source,
                    'options': x.settings.source?.options || sourceToOptions(x.settings.source, x.required),
                },
            }
            : x.settings),
    })),
});
export const unsafeMapForm = (form, map) => {
    return {
        ...form,
        'fields': form.fields.map((f) => {
            const x = f((x) => map(x));
            return (f2) => f2(x);
            // if(f((x) => x.id) !== id || f((x) => x.static))
            // {
            //   return f
            // }
            // else
            // {
            //   const x = f((x) => ({ ...x,[field]:value }))
            //   return (f2) => f2(x)
            // }
        }),
    };
};
export const staticForm = (columns) => {
    let sort = 0;
    return unsafeReifyForm({
        'columns': columns.length,
        'fields': columns.flatMap((x, i) => x.map((x) => ({
            ...x,
            'column': i + 1,
            'static': false,
            'hidden': false,
            'disabled': false,
            'sort': sort++,
        }))),
    });
};
export const adjustForm = (f) => (x) => {
    const values = formValues(x);
    return unsafeMapForm(x, (x) => f(x, values));
};
export const formValues = (form) => Object.fromEntries(form.fields.map((f) => f((x) => [x.id, x.value])));
export const formWithErrors = (form, errors) => {
    return unsafeMapForm(form, (x) => ({
        ...x,
        'errors': ((xs) => !!xs?.length ? xs : undefined)(errors?.filter((y) => y.field === x.id).map((y) => y.message)),
    }));
};
export const formFieldRemove = (s, i) => {
    return {
        ...s,
        'fields': s.fields.filter((x_) => x_((x) => x.id !== i)),
    };
};
export const formFieldAdd = (s, c, k) => {
    const x = {
        'id': crypto.randomUUID(),
        'static': false,
        'hidden': false,
        'disabled': false,
        'title': '',
        'kind': k,
        'value': kindDefault(k).value,
        'settings': kindDefault(k).settings,
        'required': false,
        'column': c,
        'sort': s.fields.reduce((agg, f) => Math.max(f((x) => x.sort), agg), 0) + 1,
    };
    return {
        ...s,
        'fields': s.fields.concat([(f) => f(x)]),
    };
};
export const formFieldEdit = (form, id, field) => (value) => {
    return unsafeMapForm(form, (x) => {
        if (x.id !== id || x.static) {
            return x;
        }
        else {
            return { ...x, [field]: value };
        }
        // if(f((x) => x.id) !== id || f((x) => x.static))
        // {
        //   return f
        // }
        // else
        // {
        //   const x = f((x) => ({ ...x,[field]:value }))
        //   return (f2) => f2(x)
        // }
    });
};
// export const formFieldEdit = <k extends Kind,f extends Exclude<keyof Field_<k>,'kind' | 'value'>>(form:Form,id:Field_<k>['id'],field:f) => (value:Field_<k>[f]) : Form => {
//   return {
//     ...form,
//     'fields':form.fields.map((f) => {
//       if(f((x) => x.id) !== id || f((x) => x.static))
//       {
//         return f
//       }
//       else
//       {
//         const x = f((x) => ({ ...x,[field]:value }))
//         return (f2) => f2(x)
//       }
//     }),
//   }
// }
export const formFieldKind = (f, i) => (k) => {
    return {
        ...f,
        'fields': f.fields.map((f) => {
            if (f((x) => x.id) !== i || f((x) => x.kind) === k || f((x) => x.static)) {
                return f;
            }
            else {
                const x = f((x) => x);
                return (f2) => f2({
                    ...x,
                    'kind': k,
                    ...kindDefault(k),
                    // ...settingsDefault(k),
                });
            }
        }),
    };
};
export const formFieldValue = (f, x) => (v) => {
    return {
        ...f,
        'fields': f.fields.map((f, i) => {
            if (f((x) => x.id) === x.id) {
                return (f2) => f2({ ...x, 'value': v });
            }
            else {
                return f;
            }
        }),
    };
};
export const mapFormField = (m) => {
    return (x) => m[x.kind](x);
};
export const mapFormFieldOne = (k, m) => {
    return mapFormField({
        'text': () => undefined,
        'number': () => undefined,
        'select': () => undefined,
        'color': () => undefined,
        'checkbox': () => undefined,
        'date': () => undefined,
        'time': () => undefined,
        'datetime': () => undefined,
        [k]: m,
    });
};
export const emitter = (f1, f2) => (x) => f1(f2(x));
